export default __webpack_public_path__ + "static/media/oneToOne.ac68722c.jpg";